import React from 'react';
import {Poi} from '../../react-app-env';

export const SelectedPoiContext = React.createContext<Poi | undefined>(undefined);

export function useSelectedPoi() {
  return React.useContext(SelectedPoiContext);
}
